<template>
  <DragDialog
    title="发布平台管理"
    :width="1200"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel"
  >
    <div class="platform-manage-box">
      <div class="operate-area-box">
        <div class="common-button-box">
          <el-button class="primary-btn" type="primary" size="small" @click="addPlatForm"
            >添加发布平台</el-button
          >
        </div>
      </div>
      <div class="paltform-table-box">
        <div v-if="loading">
          <Spin :pointNum="8" :translateX="25" background="var(--base-primary-bgColor)"  />
        </div>
        <div class="common-table-box">
          <el-table class="publish-table" highlight-selection-row height="100%" row-key="id" :data="platFormList">
            <el-table-column label="序号" type="index" width="75" />
            <el-table-column label="ID" width="250">
              <template v-slot="{ row }">
                <span>{{ row.id }}</span>
              </template>
            </el-table-column>
            <el-table-column label="名称">
              <template v-slot="{ row }">
                <span>{{ row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="在线状态">
              <template v-slot="{ row }">
                <div v-if="row.liveStatus" class="status-box">
                  <div class="circle bg-color1"></div>
                  <span class="color1">在线</span>
                </div>
                <div v-else class="status-box">
                  <div class="circle bg-color2"></div>
                  <span class="color2">离线</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="启用状态" width="200">
              <template v-slot="{ row }">
                <div class="common-switch-box">
                  <el-switch
                  class="switch-primary"
                    :value="row.status"
                    @change="(value) => togglePlatFormStatus(row, value)"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column label="创建日期" width="220">
              <template v-slot="{ row }">
                <div>{{ formatTime(row.creationTime) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="60">
              <template v-slot="{ row }">
                <div class="common-button-box operation-cell">
                  <el-button
                    type="text"
                    size="small"
                    @click="deletePlatFormById(row)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="common-empty-box">
                <bj-empty :image="require('@/assets/img/no-data.png')" class="empty-page">
                  <template slot="description">
                    <div class="empty-text">抱歉，没有找到相关内容</div>
                  </template>
                </bj-empty>
              </div>
            </template>
          </el-table>
          <div class="common-pagination-box">
            <el-pagination
            class="pagination-primary"
              popper-class="common-pagination-popper-box"
              layout="sizes, prev, pager, next, jumper"
              :page-sizes="[10, 20, 50, 100, 150, 200]"
              :page-size="pageSize"
              :current-page="currPage"
              :total="total"
              @size-change="pageSizeChange"
              @current-change="pageChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import Spin from "@/components/Spin.vue";
import DragDialog from "@/components/CustomDragDialog.vue";
import { formatTime } from "@/utils/generalMethods";

import {
  platformListService,
  deletePlatformService,
  enablePlatformService,
  disablePlatformService,
} from "@/service/interface";
export default {
  data() {
    return {
      loading: false,
      currPage: 1,
      pageSize: 10,
      total: 0,
      platFormList: [],
    };
  },
  props: {
    visible: Boolean,
    openAddPlatFormDialog: Function,
    closeDialog: Function,
  },
  components: {
    Spin,
    DragDialog,
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initPlatFormList();
      }
    },
  },
  mounted() {
    this.$eventManage.on("refreshPlatFormList", this.refreshPlatFormList);
  },
  beforeDestroy() {
    this.$eventManage.off("refreshPlatFormList", this.refreshPlatFormList);
  },
  methods: {
    initPlatFormList() {
      this.loading = true;
      this.queryPlatFormList().then((response) => {
        let { dataList, total } = response;
        this.platFormList = dataList;
        this.total = total;

        this.loading = false;
      });
    },
    refreshPlatFormList() {
      this.initPlatFormList();
    },
    addPlatForm() {
      this.openAddPlatFormDialog();
    },
    togglePlatFormStatus(platformInfo, value) {
      let platformId = platformInfo.id;
      if (value) {
        enablePlatformService(platformId).then((response) => {
          if (response.isSuccess) {
            this.$message.success("发布平台已启用");
            this.refreshPlatFormList();
          } else {
            this.$message.error(response.errMsg);
          }
        });
      } else {
        disablePlatformService(platformId).then((response) => {
          if (response.isSuccess) {
            this.$message.success("发布平台已禁用");
            this.refreshPlatFormList();
          } else {
            this.$message.error(response.errMsg);
          }
        });
      }
    },
    deletePlatFormById(platformInfo) {
      let platformId = platformInfo.id;
      deletePlatformService(platformId).then((response) => {
        if (response.isSuccess) {
          this.$message.success("删除成功");
          this.refreshPlatFormList();
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initPlatFormList();
    },
    pageChange(currPage) {
      this.currPage = currPage;
      this.initPlatFormList();
    },
    cancel() {
      this.closeDialog();
    },
    queryPlatFormList() {
      return new Promise((resolve) => {
        let params = {
          resultCount: this.pageSize,
          skipCount: (this.currPage - 1) * this.pageSize,
        };
        platformListService(params).then((response) => {
          if (response.isSuccess) {
            let data = response.data;
            let dataList = data.items;
            let total = data.totalCount;
            resolve({ dataList, total });
          } else {
            this.$message.error(response.errMsg);
          }
        });
      });
    },
    formatTime,
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.platform-manage-box {
  height: 500px;
  .operate-area-box {
    margin-bottom: 16px;
  }

  .paltform-table-box {
    height: calc(100% - 32px);
    .common-table-box {
      height: calc(100% - 64px);
      .status-box {
        display: flex;
        font-size: 12px;

        .circle {
          width: 5px;
          height: 5px;
          margin: auto 5px auto 0px;
          border-radius: 50%;
        }

        .bg-color1 {
          background: var(--table-cell-status-text-color);
        }

        .bg-color2 {
          background: var(--base-bg-light-color18);
        }

        .color1 {
          color: var(--table-cell-status-text-color);
        }

        .color2 {
          color: var(--base-bg-light-color18);
        }
      }
      .common-pagination-box {
        text-align: center;
      }
    }
  }
}
</style>